import React, { useEffect } from 'react';
import { useRouteMatch, useLocation, Redirect } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { includes } from 'lodash';
import { MainHeader, Modal, PageList, SubHeader, SyncPageHeader, PreviewPublish, GeneralSettings } from '.';
import Panel from './panel';
import SyncPage from './syncPage';
import Loader from '../loader';
import { CLIENT_STATE, SET_CLIENT_STATE, GENERAL_SETTINGS } from '../../graphqls';

export default function Admin() {
  window.zESettings = {
    webWidget: {
      helpCenter: { filter: { category: '115000978947-Public-Dashboard' } },
      contactForm: { subject: true },
      offset: {
        horizontal: '10px',
        // vertical: '60px'
      },
    },
  };
  const isSync = useRouteMatch('/sync');
  const { pathname } = useLocation();
  const isInvalid = pathname.split('/').length <= 2 && pathname.split('/')[1] !== 'sync';
  const { loading: clientStateLoading, data: { sidebarMask, sideMenu } = {} } = useQuery(CLIENT_STATE);
  const {
    loading: loadingGeneralSettings,
    data: { generalSettings: { accountEmail } = {} } = {},
    startPolling,
    stopPolling,
  } = useQuery(GENERAL_SETTINGS);
  const [setState] = useMutation(SET_CLIENT_STATE);
  const onClose = () => setState({ variables: { sideMenu: '' } });

  if (isInvalid) {
    return <Redirect to="/home/edit" />;
  }

  if (clientStateLoading || loadingGeneralSettings) {
    return <Loader>We&apos;re loading your workspace</Loader>;
  }

  return (
    <div className="App">
      {sidebarMask && (
        <div className="loading-overlay">
          <Loader loadingMessage="Saving the changes" />
        </div>
      )}
      <div className="app-inner-wrapper">
        <div className="app-header-wrapper">
          <MainHeader startPolling={startPolling} stopPolling={stopPolling} />
          {isSync ? <SyncPageHeader /> : <SubHeader />}
        </div>
        <div className={`${isSync ? 'sync-page ' : ''}layout-split-pane-container`}>
          {isSync ? (
            <SyncPage />
          ) : (
            <>
              <Panel />
              <PageList routeType="main" />
            </>
          )}
          <GeneralSettings />
          <PreviewPublish />
          <Modal startPolling={startPolling} stopPolling={stopPolling} />
        </div>
        {includes(['generalSettingsView', 'PreviewPublishDropdown'], sideMenu) ? (
          <div className="general-settings-overlay overlay" onClick={onClose} onKeyPress={() => {}} role="button" tabIndex="0" />
        ) : null}
      </div>
    </div>
  );
}
